import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, convertToNumber, deleteData, handleDateChange } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBox, DateBox, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const ClientMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const Hide = false;
    const [formData, setFormData] = useState({
        "clientID": '',
        "cCode": '',
        "cName": '',
        "clientPassword": '',
        "bCode": '',
        "contactPerson": '',
        "address1": '',
        "address2": '',
        "address3": '',
        "cityCode": '',
        "stateCode": '',
        "countryCode": '',
        "zipCode":'',
        "phoneNo": '',
        "eMailID": '',
        "panNo": '',
        "aadhaarNo": '',
        "serviceTaxNo": '',
        "introductionDate": '',
        "remarks": '',
        "active": true
    })

    const handleClear = () => {
        setFormData({
            "clientID": '',
            "cCode": '',
            "cName": '',
            "clientPassword": '',
            "bCode": '',
            "contactPerson": '',
            "address1": '',
            "address2": '',
            "address3": '',
            "cityCode": '',
            "stateCode": '',
            "countryCode": '',
            "zipCode": '',
            "phoneNo": '',
            "eMailID": '',
            "panNo": '',
            "aadhaarNo": '',
            "serviceTaxNo": '',
            "introductionDate": '',
            "remarks": '',
            "active": true
        });
        filterData.SearchText = ''
        getClientMasterData()
        inputrefs.current['txtClientName'].focus();
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateClientMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteClientMaster', { clientID: ID }, getClientMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditClientMaster', { clientID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    const getClientMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowClientMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getClientMasterData(value);
    };

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };
    const HidePassword = false
    useEffect(() => {
        getClientMasterData();
    }, [sortConfig])

    useEffect(() => {
       inputrefs.current['txtClientName'].focus();
        document.title = 'Client Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText :FindTranslatedKey('Client Master')}</h6>
                </div>
                <div className='card-body row'>
                 {/*   {Hide ? <>*/}
                        <div className='row'>
                            <InputBox
                                label='Client Code'
                                PlaceHolderText='System Generated'
                                inputrefs={inputrefs}
                                id='txtClientCode'
                                value={formData.cCode}
                                disabled={true}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, cCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtClientName'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Client Name'
                                PlaceHolderText='Client Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtClientName'
                                value={formData.cName}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, cName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBranchCode'].focus();
                                    }
                                }}
                        />
                        {HidePassword ? <>
                            <InputBox
                                label='Client Password'
                                PlaceHolderText='Client Password'
                                type="password"
                                required={true}
                                inputrefs={inputrefs}
                                id='txtClientPassword'
                                value={formData.clientPassword}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, clientPassword: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBranchCode'].focus();
                                    }
                                }}
                            />

                        </> : <></>}
                           
                            <AutoCompleteBox
                                label='Branch Code'
                                placeholder='Branch Code'
                                inputValue={formData.bCode ? formData.bCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetBranch');
                                        setFormData({ ...formData, bCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtBranchCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtContactPerson'].focus() };
                                }}
                            />
                            <InputBox
                                label='Contact Person'
                                PlaceHolderText='Contact Person'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtContactPerson'
                                value={formData.contactPerson}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, contactPerson: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress1'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Address 1'
                                PlaceHolderText='Address 1'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtAddress1'
                                value={formData.address1}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address1: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress2'].focus();
                                    }
                                }}
                            /><InputBox
                                label='Address 2'
                                 PlaceHolderText='Address 2'
                                inputrefs={inputrefs}
                                id='txtAddress2'
                                value={formData.address2}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address2: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress3'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Address 3'
                                 PlaceHolderText='Address 3'
                                inputrefs={inputrefs}
                                id='txtAddress3'
                                value={formData.address3}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address3: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCountryCode'].focus();
                                    }
                                }}
                            />
                            <AutoCompleteBox
                                label='Country'
                                placeholder='Country'
                                inputValue={formData.countryCode ? formData.countryCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                        setFormData({ ...formData, countryCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCountryCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtStateCode'].focus() };
                                }}
                            />

                            <AutoCompleteBox

                                label='State'
                                placeholder='State'
                                inputValue={formData.stateCode ? formData.stateCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.countryCode, 'GetState_CountryWise');
                                        setFormData({ ...formData, stateCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtStateCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtCityCode'].focus() };
                                }}
                            />

                            <AutoCompleteBox
                                label='City'
                                placeholder='City'
                                inputValue={formData.cityCode ? formData.cityCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.stateCode, 'GetCity_StateWise');
                                        setFormData({ ...formData, cityCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCityCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPinCode'].focus() };
                                }}
                            />
                            <AutoCompleteBox
                                label='Pin Code'
                                placeholder='Pin Code'
                                inputValue={formData.zipCode ? formData.zipCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.cityCode, 'GetPinCode_CityWise');
                                        setFormData({ ...formData, zipCode: newInputValue })
                                    }}
                                maxLength='6'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPinCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPhoneNo'].focus() };
                                }}
                            />
                            <InputBox
                                label='Phone Number'
                                PlaceHolderText='Phone Number'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPhoneNo'
                                value={formData.phoneNo}
                                maxLength='15'
                                onChange={(e) => {
                                    setFormData({ ...formData, phoneNo: convertToNumber(e.target.value) })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEMailID'].focus();
                                    }
                                }}
                            />
                            {/*<InputBox*/}
                            {/*    label='Pin Code'*/}
                            {/*    placeholder='Pin Code'*/}
                            {/*    required={true}*/}
                            {/*    inputrefs={inputrefs}*/}
                            {/*    id='txtPinCode'*/}
                            {/*    value={formData.zipCode}*/}
                            {/*    maxLength='20'*/}
                            {/*    onChange={(e) => {*/}
                            {/*        setFormData({ ...formData, zipCode: e.target.value })*/}
                            {/*    }}*/}
                            {/*    onKeyDown={(e) => {*/}
                            {/*        if (e.key === 'Enter') {*/}
                            {/*            inputrefs.current['txtEmailID'].focus();*/}
                            {/*        }*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <InputBox
                                label='Email ID'
                                PlaceHolderText='Email ID'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtEMailID'
                                value={formData.eMailID}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, eMailID: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtServiceTaxNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='GST Number'
                                PlaceHolderText='GST Number'
                               // required={true}
                                inputrefs={inputrefs}
                                id='txtServiceTaxNo'
                                value={formData.serviceTaxNo}
                                maxLength='15'
                                onChange={(e) => {
                                    setFormData({ ...formData, serviceTaxNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPanNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Pan No'
                                PlaceHolderText='Pan No'
                               // required={true}
                                inputrefs={inputrefs}
                                id='txtPanNo'
                                value={formData.panNo}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, panNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAadhaarNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Aadhaar No'
                                PlaceHolderText='Aadhaar No'
                               // required={true}
                                inputrefs={inputrefs}
                                id='txtAadhaarNo'
                                value={formData.aadhaarNo}
                                maxLength='12'
                                onChange={(e) => {
                                    setFormData({ ...formData, aadhaarNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtIntroductionDate'].focus();
                                    }
                                }}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Introduction Date"
                                placeholder="Introduction Date"
                                id='txtIntroductionDate'
                                //  value={formData.introductionDate ? formData.introductionDate : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtRemarks'].focus()
                                    };
                                }}
                                required={true}
                                selected={formData.introductionDate === '' ? '' : new Date(formData.introductionDate)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'introductionDate')}
                            />
                            <InputBox
                                label='Remarks'
                                PlaceHolderText='Remarks'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtRemarks'
                                value={formData.remarks}
                                maxLength='30'
                                onChange={(e) => {
                                    setFormData({ ...formData, remarks: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus();
                                    }
                                }}
                            />
                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='txtActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                        </div>
                  {/*  </> : <></>}*/}
                   
                    <div className='row pb-1'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                           // save={false}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/Master/ShowClientMaster', filterData, 'Client Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={'ClientMaster'}
                        loading={loading}
                        handleFilter={() => {
                            getClientMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
            </div>

          
        </>
    )
}

export default ClientMaster;